import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/panzhijing/\u86CB\u5377\u79D1\u6280/danjuan-admin/node_modules/_@babel_runtime-corejs2@7.26.0@@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "/Users/panzhijing/\u86CB\u5377\u79D1\u6280/danjuan-admin/node_modules/_@babel_runtime-corejs2@7.26.0@@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import * as _ from 'lodash';
import dispatchApi from '@/api/dispatch';
import orderApi from '@/api/order';
var state = {
  queryOrderList: null,
  loading: false,
  circleSearch: [],
  switchTabState: 1,
  completeOrderList: null,
  completeOrderloading: false,
  orderList: [],
  cascaderOptions: [],
  carCardList: [],
  orderData: {},
  emptyNumber: 0,
  emptyDisane: 500,
  historyList: JSON.parse(window.localStorage.getItem("historyList") || '[]')
};
var mutations = {
  SET_HISTORY_LIST: function SET_HISTORY_LIST(state, obj) {
    var list = state.historyList.slice(0, 49);
    list.unshift(obj);
    window.localStorage.setItem("historyList", JSON.stringify(list));
    state.historyList = _toConsumableArray(list);
  },
  QUERY_ORDER_LIST: function QUERY_ORDER_LIST(state, params) {
    state.queryOrderList = params;
  },
  QUERY_ORDER_LOADING: function QUERY_ORDER_LOADING(state, params) {
    state.loading = params;
  },
  CIRCLE_SEARCH_LIST: function CIRCLE_SEARCH_LIST(state, params) {
    state.circleSearch = params;
  },
  SWITCH_TAB_STATE: function SWITCH_TAB_STATE(state, params) {
    state.switchTabState = params;
  },
  COMPLETE_ORDER_LIST: function COMPLETE_ORDER_LIST(state, params) {
    state.completeOrderList = params;
  },
  COMPLETE_ORDER_LOADING: function COMPLETE_ORDER_LOADING(state, params) {
    state.completeOrderloading = params;
  },
  ORDER_LIST: function ORDER_LIST(state, params) {
    state.orderList.push(params);
  },
  CASCADER_OPTIONS: function CASCADER_OPTIONS(state, params) {
    state.cascaderOptions = _toConsumableArray(params);
  },
  CAR_CARD_LIST: function CAR_CARD_LIST(state, params) {
    var defaultList = [];
    var industryList = [];
    params.driverRecordList && params.driverRecordList.forEach(function (val) {
      if (val.dataFrom === 1) {
        defaultList.push(val);
      }
      if (val.dataFrom === 4501001) {
        industryList.push(val);
      }
    });
    params.defaultList = [].concat(defaultList);
    params.industryList = [].concat(industryList);
    state.carCardList.push(params);
  },
  ORDER_DATA: function ORDER_DATA(state, params) {
    state.orderData = params;
  },
  EMPTY_NUMBER: function EMPTY_NUMBER(state, params) {
    state.emptyNumber = params;
  },
  EMPTY_DISANCE: function EMPTY_DISANCE(state, params) {
    state.emptyDisane = params;
  }
};
var actions = {
  getGueryOrderList: function () {
    var _getGueryOrderList = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref, params) {
      var commit, res, status, message, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            _context.prev = 1;
            commit('QUERY_ORDER_LOADING', true);
            _context.next = 5;
            return dispatchApi.queryOrderList(params);
          case 5:
            res = _context.sent;
            status = res.status, message = res.message, data = res.data;
            if (!(status === '0')) {
              _context.next = 12;
              break;
            }
            commit('QUERY_ORDER_LIST', data);
            // commit('QUERY_ORDER_LOADING', false)
            return _context.abrupt("return", data);
          case 12:
            commit('QUERY_ORDER_LOADING', false);
            return _context.abrupt("return", Promise.reject('请求失败，' + message));
          case 14:
            _context.next = 19;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](1);
            commit('QUERY_ORDER_LOADING', false);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 16]]);
    }));
    function getGueryOrderList(_x, _x2) {
      return _getGueryOrderList.apply(this, arguments);
    }
    return getGueryOrderList;
  }(),
  getCompleteOrder: function () {
    var _getCompleteOrder = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref2, params) {
      var commit, res, status, message, data;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            commit = _ref2.commit;
            commit('COMPLETE_ORDER_LOADING', true);
            _context2.prev = 2;
            _context2.next = 5;
            return dispatchApi.queryOrderList(params);
          case 5:
            res = _context2.sent;
            status = res.status, message = res.message, data = res.data;
            if (!(status === '0')) {
              _context2.next = 13;
              break;
            }
            commit('COMPLETE_ORDER_LIST', data);
            commit('COMPLETE_ORDER_LOADING', false);
            return _context2.abrupt("return", data);
          case 13:
            commit('COMPLETE_ORDER_LOADING', false);
            return _context2.abrupt("return", Promise.reject('请求失败，' + message));
          case 15:
            _context2.next = 20;
            break;
          case 17:
            _context2.prev = 17;
            _context2.t0 = _context2["catch"](2);
            commit('COMPLETE_ORDER_LOADING', false);
          case 20:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[2, 17]]);
    }));
    function getCompleteOrder(_x3, _x4) {
      return _getCompleteOrder.apply(this, arguments);
    }
    return getCompleteOrder;
  }(),
  circleSearchByLoad: function () {
    var _circleSearchByLoad = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref3, params) {
      var commit, res, status, message, data;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            commit = _ref3.commit;
            _context3.next = 3;
            return dispatchApi.circleSearchByLoad(params);
          case 3:
            res = _context3.sent;
            status = res.status, message = res.message, data = res.data;
            if (!(status === '0')) {
              _context3.next = 10;
              break;
            }
            commit('CIRCLE_SEARCH_LIST', data);
            return _context3.abrupt("return", res);
          case 10:
            return _context3.abrupt("return", Promise.reject('请求失败，' + message));
          case 11:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function circleSearchByLoad(_x5, _x6) {
      return _circleSearchByLoad.apply(this, arguments);
    }
    return circleSearchByLoad;
  }(),
  queryOrder: function () {
    var _queryOrder = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref4, params) {
      var commit, res, status, message, data;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            commit = _ref4.commit;
            _context4.next = 3;
            return dispatchApi.queryOrderList(params);
          case 3:
            res = _context4.sent;
            status = res.status, message = res.message, data = res.data;
            if (!(status === '0')) {
              _context4.next = 10;
              break;
            }
            commit('ORDER_DATA', data.jsonOrderList[0]);
            return _context4.abrupt("return", res);
          case 10:
            return _context4.abrupt("return", Promise.reject('请求失败，' + message));
          case 11:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function queryOrder(_x7, _x8) {
      return _queryOrder.apply(this, arguments);
    }
    return queryOrder;
  }(),
  GetEmptyList: function () {
    var _GetEmptyList = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref5, params) {
      var commit, res, status, message, data;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            commit = _ref5.commit;
            _context5.next = 3;
            return dispatchApi.circleSearchWithPushOrNotLoad(params);
          case 3:
            res = _context5.sent;
            status = res.status, message = res.message, data = res.data;
            if (!(status === '0')) {
              _context5.next = 10;
              break;
            }
            if (data.vehicleLocationVoList !== undefined && Array.isArray(data.vehicleLocationVoList)) {
              commit('EMPTY_NUMBER', data.vehicleLocationVoList.length);
            } else {
              commit('EMPTY_NUMBER', 0);
            }
            return _context5.abrupt("return", res);
          case 10:
            return _context5.abrupt("return", Promise.reject('请求失败，' + message));
          case 11:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    function GetEmptyList(_x9, _x10) {
      return _GetEmptyList.apply(this, arguments);
    }
    return GetEmptyList;
  }()
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};